import type Lenis from "lenis";

/** Section id for the careers application form (must match `id` on the DOM). */
export const CAREERS_APPLICATION_SECTION_ID = "careers-application";

const DEFAULT_HEADER_RESERVE_PX = 96;

/**
 * Scrolls so the element with `id` sits below the fixed header.
 * When Lenis is active, native `window.scrollTo` / hash navigation often do nothing — use this instead.
 */
export function scrollToElementId(
  id: string,
  lenis: Lenis | null | undefined,
  headerReservePx: number = DEFAULT_HEADER_RESERVE_PX,
): boolean {
  if (typeof document === "undefined") return false;
  const el = document.getElementById(id);
  if (!el) return false;

  const offset = -(headerReservePx + 16);

  if (lenis) {
    lenis.scrollTo(el, { offset });
    return true;
  }

  const top = el.getBoundingClientRect().top + window.scrollY + offset;
  window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  return true;
}
